import { Injectable } from '@angular/core';
import { UserSettings } from '@user/model/user-settings';
import { LabelingCategory } from '@article/labeling/labeling.category';

export interface CaeImportOptions {
  groupCarrierBlocks: boolean;
  startProjection: number;
  openLeftSide: boolean;
  groupDistance: number;
  bmkFunctionalAssignment: boolean;
  bmkFunctionDesignation: boolean;
  bmkInstallationSite: boolean;
  bmkLocationDesignation: boolean;
  bmkDevice: boolean;
  addEndstopBmk: boolean;
  addLabelBmk: boolean;
  levelTopDown: boolean;
  textRotation: number;
  labelingCategory: LabelingCategory;
  useQuickImport: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CaeImportOptionsService {

  constructor(
    private userSettings: UserSettings,
  ) { }

  public load(): CaeImportOptions {
    return {
      groupCarrierBlocks: this.userSettings.getUserSettingBooleanValue("caeImportGroupCarrierBlocks", false),
      startProjection: this.userSettings.getUserSettingNumberValue('caeImportStartProjection', 20),
      openLeftSide: false,
      groupDistance: this.userSettings.getUserSettingNumberValue('caeImportGroupDistance', 30),
      bmkFunctionalAssignment: this.userSettings.getUserSettingBooleanValue('caeImportBmkSystem', true),
      bmkFunctionDesignation: this.userSettings.getUserSettingBooleanValue('caeImportBmkSystemDesignation', true),
      bmkInstallationSite: this.userSettings.getUserSettingBooleanValue('caeImportBmkPlace', true),
      bmkLocationDesignation: this.userSettings.getUserSettingBooleanValue('caeImportBmkPlaceDesignation', true),
      bmkDevice: this.userSettings.getUserSettingBooleanValue('caeImportBmkTerminal', true),
      addEndstopBmk: this.userSettings.getUserSettingBooleanValue('caeImportAddEndstopBmk', false),
      addLabelBmk: this.userSettings.getUserSettingBooleanValue('caeImportAddLabelBmk', false),
      levelTopDown: this.userSettings.getUserSettingBooleanValue('caeImportLevelTopDown', true),
      textRotation: this.userSettings.getUserSettingNumberValue('caeImportTextRotation', 0),
      labelingCategory: this.userSettings.getUserSettingStringValue('caeImportLabelingCategory', 'strip') as LabelingCategory,
      useQuickImport: this.userSettings.getUserSettingBooleanValue('caeUseQuickImport', false),
    };
  }

  public save(options: CaeImportOptions): void {
    this.userSettings.setUserSettingValue('caeImportGroupCarrierBlocks', options.groupCarrierBlocks);
    this.userSettings.setUserSettingValue('caeImportStartProjection', options.startProjection);
    this.userSettings.setUserSettingValue('caeImportGroupDistance', options.groupDistance);
    this.userSettings.setUserSettingValue('caeImportBmkSystem', options.bmkFunctionalAssignment);
    this.userSettings.setUserSettingValue('caeImportBmkSystemDesignation', options.bmkFunctionDesignation);
    this.userSettings.setUserSettingValue('caeImportBmkPlace', options.bmkInstallationSite);
    this.userSettings.setUserSettingValue('caeImportBmkPlaceDesignation', options.bmkLocationDesignation);
    this.userSettings.setUserSettingValue('caeImportBmkTerminal', options.bmkDevice);
    this.userSettings.setUserSettingValue('caeImportAddEndstopBmk', options.addEndstopBmk);
    this.userSettings.setUserSettingValue('caeImportAddLabelBmk', options.addLabelBmk);
    this.userSettings.setUserSettingValue('caeImportLevelTopDown', options.levelTopDown);
    this.userSettings.setUserSettingValue('caeImportTextRotation', options.textRotation);
    this.userSettings.setUserSettingValue('caeImportLabelingCategory', options.labelingCategory);
    this.userSettings.setUserSettingValue('caeUseQuickImport', options.useQuickImport);
  }
}
